import{__rest as i}from"../_virtual/_tslib.js";import{jsx as e}from"react/jsx-runtime";import{createElement as t}from"react";import{calculateRem as r}from"@vds-core/utilities";import{ColorTokens as n}from"@vds-tokens/color";import{Fonts as o}from"@vds-core/typography";import{TypographyTokens as d}from"@vds-tokens/typography";import a from"styled-components";const l=a.div.withConfig({displayName:"StyledHeader",componentId:"VDS__sc-rfou8v-0"})`
  ${function({$rightPadding:i}){return i&&"\n  padding-right: 40px;\n  "}}
  &:hover,
  &:active,
  &:visited {
    outline: none;
  }
`,m=a((function(e){var{primitive:r}=e,n=i(e,["primitive"]);return t(r,n)})).withConfig({displayName:"StyledHeaderText",componentId:"VDS__sc-rfou8v-1"})`
  color: ${function({surface:i}){return"dark"===i?n.elements.primary.ondark.value:n.elements.primary.onlight.value}};
  font-size: ${r(d.fontsize.title[24].value)};
  line-height: ${r(d.lineheight.title[28].value)};
  font-family: ${o.VerizonNHGeDS};
  padding: ${function({padding:i}){return i}};
  margin: 0;
  flex: 1;

  @media (min-width: 767px) {
    font-size: ${r(d.fontsize.title[32].value)};
    line-height: ${r(d.lineheight.title[36].value)};
  }
`,p=function(i){const{children:t,primitive:r,padding:n,rightPadding:o,surface:d}=i;return e(l,{$rightPadding:o,"data-testid":"modal-header",children:e(m,{padding:n,primitive:r,surface:d,children:t})})};p.defaultProps={children:null,primitive:"h2",rightPadding:!1,padding:"0px",surface:"light"};export{p as default};
